import { Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useFavorites } from '@/hooks/useFavorites';

interface FavoriteButtonProps {
  variantId: string;
  /** Kompakt ikonknap til bilkort, bred knap med tekst til bilsiden */
  variantStyle?: 'icon' | 'full';
  className?: string;
}

export function FavoriteButton({ variantId, variantStyle = 'icon', className }: FavoriteButtonProps) {
  const { favoriteIds, toggleFavorite, isToggling } = useFavorites();
  const isFavorite = favoriteIds.has(variantId);

  const label = isFavorite ? 'Fjern fra favoritter' : 'Gem som favorit';

  if (variantStyle === 'full') {
    return (
      <Button
        type="button"
        variant={isFavorite ? 'default' : 'outline'}
        disabled={isToggling}
        onClick={() => toggleFavorite(variantId)}
        className={cn('gap-2', className)}
      >
        <Heart className={cn('w-4 h-4', isFavorite && 'fill-current')} aria-hidden />
        {isFavorite ? 'Gemt' : 'Gem bil'}
      </Button>
    );
  }

  return (
    <Button
      type="button"
      size="icon"
      variant="ghost"
      aria-label={label}
      title={label}
      disabled={isToggling}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(variantId);
      }}
      className={cn('h-11 w-11 rounded-full bg-background/80 backdrop-blur', className)}
    >
      <Heart
        className={cn('w-5 h-5', isFavorite ? 'fill-primary text-primary' : 'text-muted-foreground')}
        aria-hidden
      />
    </Button>
  );
}
